import { ApprovalFiltersI, UpdateStatusValuesI } from "../../../redux/approvals/approvalsTypes";
import { OrderTypes } from "../../listOptions";
import { number, object, string } from "yup";

export const sortByInitialValue = {
  id          : "pick_up_date",
  description : "Pick up Date",
};
export const initialValues: ApprovalFiltersI = {
  page     : 1,
  limit    : 20,
  sort_by  : sortByInitialValue,
  order_by : OrderTypes.DESC,
};
export const initialValuesHistory: ApprovalFiltersI = {
  ...initialValues,
  ignore_default_time_filter: false,
};

export const statusModalValidationSchema = object({
  status: object().shape({
    id          : string().required("Status is required"),
    description : string().required(),
  }),
  rate: number().when("status", {
    is        : (status: any) => status?.id === "counter",
    then      : number().positive().max(99999).required("Rate is required"),
    otherwise : number().notRequired(),
  }),
  status_comment: string(),
});

export const updateStatusInitialValues: UpdateStatusValuesI = {
  status: {
    id          : "",
    description : "",
  },
  status_comment: "",
};
